import React from "react";
export const useMessageResponse = () => {
  const [messageResponse, setMessageResponse] = React.useState("");
  const updateMessageResponse = body => {
    setMessageResponse(body);
  };
  const clearMessageResponse = () => {
    setMessageResponse("");
  };
  return {
    messageResponse,
    updateMessageResponse,
    clearMessageResponse
  };
};